import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useCity } from "../context/CityContext";
import "swiper/css/pagination";
import "../styles/NewHome.css";
import { API_BASE_URL } from "../config";

const HomeEventBanner = () => {
  const [banners, setBanners] = useState([]);
  const { selectedCity } = useCity();

  useEffect(() => {
    const token = localStorage.getItem("token");

    const cityParam = selectedCity ? `&city=${selectedCity}` : "";
    const url = `${API_BASE_URL}/events?page=1&npp=70${cityParam}`;

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("API DATA 👉", data);
        setBanners(data?.result || []);
      })
      .catch((err) => console.error("API Error ❌", err));
  }, [selectedCity]);

  if (!banners.length) return null;
  return (
    banners.length > 0 && (
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={700}
        loop
        spaceBetween={0}
        slidesPerView="auto"
        centeredSlides={true}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 1,
        }}
      >
        {banners.map((item, index) => {
          const meta = item.metadata;
          const dateObj = new Date(meta?.start_date);
          const day = dateObj.toLocaleDateString("en-GB", { day: "2-digit" });
          const month = dateObj.toLocaleDateString("en-GB", { month: "short" });
          return (
            <SwiperSlide key={index} className="mySwiper">
  <div className="bannerCard">
    <img
      src={item?.banner_file?.base64}
      alt={meta?.name || "Event Banner"}
    />

    <div className="bannerOverlay">

      <div className="glassCard">

        <div className="left">
          <h2>{meta?.name}</h2>
        </div>

        <div className="center">
          <span className="day">{day}</span>
          <span className="month">{month}</span>
        </div>

        <div className="right">
          <p>
            <strong>Venue:</strong> {meta?.venue}
          </p>

          <p>
            <strong>City:</strong> {meta?.city}
          </p>
        </div>

      </div>

      {/* Badge OUTSIDE glassCard */}
      <span
        className={`entryBadge ${meta?.is_event_free ? "free" : "paid"}`}
      >
        {meta?.is_event_free ? "FREE ENTRY" : "PAID ENTRY"}
      </span>

    </div>
  </div>
</SwiperSlide>
          );
        })}
      </Swiper>
    )
  );
};

export default HomeEventBanner;
